<div
  class="debug-panel"
  [style.left.px]="posX"
  [style.top.px]="posY"
>
  <div class="debug-header" (mousedown)="onHeaderMouseDown($event)">
    <span class="debug-title">VOD Debug</span>
    <button class="debug-close" (click)="closed.emit()">&#x2715;</button>
  </div>

  <div class="debug-body">
    <!-- VOD Timeline -->
    <div class="debug-section-header" (click)="toggleSection('timeline')">
      {{ collapsedSections['timeline'] ? '&#9654;' : '&#9660;' }} VOD Timeline
    </div>
    <div *ngIf="!collapsedSections['timeline'] && timelineSnapshot">
      <div class="debug-section">
        <div class="debug-section-title">Timeline State</div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['timelineBlockDurationSecs']">timelineBlockDurationSecs</span>
          <span class="debug-value">{{ timelineSnapshot.timelineBlockDurationSecs }}<br><small>{{ formatSecsTimecode(timelineSnapshot.timelineBlockDurationSecs) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isVideoTimelineFit']">isVideoTimelineFit</span>
          <span class="debug-value">{{ timelineSnapshot.isVideoTimelineFit }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isFitSegment']">isFitSegment</span>
          <span class="debug-value">{{ timelineSnapshot.isFitSegment }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['selectedSegmentId']">selectedSegmentId</span>
          <span class="debug-value">{{ timelineSnapshot.selectedSegmentId ?? 'none' }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['timelineMode']">timelineMode</span>
          <span class="debug-value">{{ timelineSnapshot.timelineMode }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['oneFrameSecs']">oneFrameSecs</span>
          <span class="debug-value">{{ timelineSnapshot.oneFrameSecs | number:'1.6-6' }}<br><small>{{ formatSecsTimecode(timelineSnapshot.oneFrameSecs) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['videoFps']">videoFps</span>
          <span class="debug-value">{{ timelineSnapshot.videoFps }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['pixelsPerSecond']">pixelsPerSecond</span>
          <span class="debug-value">{{ timelineSnapshot.pixelsPerSecond | number:'1.3-3' }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['currentVideoTime']">currentVideoTime</span>
          <span class="debug-value">{{ timelineSnapshot.currentVideoTime | number:'1.3-3' }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['currentVideoPlayTimeSecs']">currentVideoPlayTimeSecs</span>
          <span class="debug-value">{{ timelineSnapshot.currentVideoPlayTimeSecs | number:'1.3-3' }}<br><small>{{ formatSecsTimecode(timelineSnapshot.currentVideoPlayTimeSecs) }}</small></span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['currentVideoPlayTimeInMs']">currentVideoPlayTimeInMs</span>
          <span class="debug-value">{{ timelineSnapshot.currentVideoPlayTimeInMs | number:'1.0-0' }}<br><small>{{ formatMsTimecode(timelineSnapshot.currentVideoPlayTimeInMs) }}</small></span>
        </div>
      </div>

    </div>

    <!-- VOD ViewModel -->
    <div class="debug-section-header" (click)="toggleSection('vm')">
      {{ collapsedSections['vm'] ? '&#9654;' : '&#9660;' }} VOD ViewModel
    </div>
    <div *ngIf="!collapsedSections['vm'] && vmSnapshot">
      <div class="debug-section">
        <div class="debug-section-title">State</div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['showDebugPanel']">showDebugPanel</span>
          <span class="debug-value">{{ vmSnapshot.showDebugPanel }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['segmentsCount']">segmentsCount</span>
          <span class="debug-value">{{ vmSnapshot.segmentsCount }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isAudioMuted']">isAudioMuted</span>
          <span class="debug-value">{{ vmSnapshot.isAudioMuted }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isAudioForcedMuted']">isAudioForcedMuted</span>
          <span class="debug-value">{{ vmSnapshot.isAudioForcedMuted }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['selectedAudioOption']">selectedAudioOption</span>
          <span class="debug-value">{{ vmSnapshot.selectedAudioOption }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['timelineMode']">timelineMode</span>
          <span class="debug-value">{{ vmSnapshot.timelineMode }}</span>
        </div>
        <div class="debug-row">
          <span class="debug-label" [attr.data-tooltip]="tooltips['isFitSegment']">isFitSegment</span>
          <span class="debug-value">{{ vmSnapshot.isFitSegment }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
